import { getStoredJwt } from "./authApi";
import { sanitizeThemePreference, type ThemePreference } from "../styles/themePalette";

export async function apiGetMeTheme(): Promise<ThemePreference> {
  const token = getStoredJwt();
  if (!token) throw new Error("нет токена");
  const res = await fetch("/api/me/theme", {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = (await res.json()) as { theme?: unknown; error?: string };
  if (!res.ok) {
    throw new Error(data.error ?? `theme (${res.status})`);
  }
  return sanitizeThemePreference(data.theme);
}

export async function apiPatchMeTheme(theme: ThemePreference): Promise<{ theme: ThemePreference }> {
  const token = getStoredJwt();
  if (!token) throw new Error("нет токена");
  const res = await fetch("/api/me/theme", {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ theme }),
  });
  const data = (await res.json()) as { theme?: unknown; error?: string };
  if (!res.ok) {
    throw new Error(data.error ?? `theme save (${res.status})`);
  }
  return { theme: sanitizeThemePreference(data.theme) };
}
